import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PublicPage from './pages/PublicPage';
import ResultsPage from './pages/ResultsPage';
import TeamsPage from './pages/TeamsPage';
import TeamDetailPage from './pages/TeamDetailPage';
import NewsPage from './pages/NewsPage';
import ClubNewsPage from './pages/ClubNewsPage';
import StatisticsPage from './pages/StatisticsPage';
import LivePage from './pages/LivePage';
import CalendarPage from './pages/CalendarPage';
import CommuniquesPage from './pages/CommuniquesPage';
import CommitteesPage from './pages/CommitteesPage';
import DesignationsPage from './pages/DesignationsPage';
import DisciplinePage from './pages/DisciplinePage';
import GroupsPage from './pages/GroupsPage';
import StandingsPage from './pages/StandingsPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminDashboardV2 from './pages/AdminDashboardV2';
import MediaPage from './pages/MediaPage';
import UsefulLinksPage from './pages/UsefulLinksPage';
import TopBar from './components/TopBar';
import Navbar from './components/NavbarWithGroups';
import FloatingShareButton from './components/FloatingShareButton';
import { useLanguage } from './context/LanguageContext';

function App() {
  const isAuthenticated = !!localStorage.getItem('token');
  const { language } = useLanguage();

  // Appliquer la direction RTL/LTR au document
  React.useEffect(() => {
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  return (
    <Router>
      <TopBar />
      <Navbar isAdmin={isAuthenticated} />
      <FloatingShareButton />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/useful-links" element={<UsefulLinksPage />} />
        <Route path="/championship" element={<PublicPage />} />
        <Route path="/matches" element={<PublicPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/standings" element={<StandingsPage />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/teams/:id" element={<TeamDetailPage />} />
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/club-news" element={<ClubNewsPage />} />
        <Route path="/statistics" element={<StatisticsPage />} />
        <Route path="/live" element={<LivePage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/communiques" element={<CommuniquesPage />} />
        <Route path="/committees" element={<CommitteesPage />} />
        <Route path="/regulations" element={<CommuniquesPage />} />
        <Route path="/laws" element={<CommuniquesPage />} />
        <Route path="/designations" element={<DesignationsPage />} />
        <Route path="/discipline" element={<DisciplinePage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboardV2 />} />
        <Route path="/admin/dashboard-old" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
